import {combineReducers} from 'redux'
import types from 'customer/types/Accounts.types'
import createReducer from 'customer/reducers/createReducer'
import createRequestReducer from 'customer/reducers/createRequestReducer'

const INITIAL_DATA_STATE = []
const data = createReducer(INITIAL_DATA_STATE, {
  [types.FULFILLED_GET_ACCOUNTS]: (_, action) => action.data.accounts
})

const INITIAL_ERROR_STATE = {}
const error = createReducer(INITIAL_ERROR_STATE, {
  [types.FULFILLED_GET_ACCOUNTS]: () => INITIAL_ERROR_STATE,
  [types.REJECTED_GET_ACCOUNTS]: (_, action) => action.error
})

const getStatus = createRequestReducer(types.GET_ACCOUNTS)

export default combineReducers({data, error, getStatus})
